import { Component, inject, OnInit } from '@angular/core';
import { TableColumn } from 'src/app/components/table/models/tableColumn';
import { ShopConfigService } from 'src/app/connect-api/api/shop/shop-config.service';

@Component({
  selector: 'app-shopping-errors',
  templateUrl: './shopping-errors.component.html',
  styleUrl: './shopping-errors.component.scss'
})
export class ShoppingErrorsComponent implements OnInit {
  protected shopConfigService = inject(ShopConfigService);
  errors: any[] = [];
  cols: TableColumn[] = [
    new TableColumn.Builder()
      .setHeader('Código')
      .setField('code')
      .setRouterLink('/configuracoes/shop-errors/')
      .setRouterLinkFieldName('code')
      .build(),
    new TableColumn('Título', 'title', true, 'text'),
    new TableColumn('Mensagem', 'message', true, 'text')
  ];

  async ngOnInit() {
    this.errors = await this.shopConfigService.getErrorsList();
  }
}
